import {SignalOptions} from 'solid-js/types/reactive/signal'
import {Accessor, createSignal} from 'solid-js'

export function createToggleSignal(value = false, options?: SignalOptions<boolean>): ToggleSignal {
    const [isOn, setIsOn] = createSignal<boolean>(value, options)
    return [isOn, () => setIsOn(prev => !prev)]
}

export type ToggleSignal = [Accessor<boolean>, () => boolean]